import { render } from "./ubuntu_body_banner8.vue?vue&type=template&id=0d6ac9ea&scoped=true"
import script from "./ubuntu_body_banner8.vue?vue&type=script&lang=js"
export * from "./ubuntu_body_banner8.vue?vue&type=script&lang=js"

import "./ubuntu_body_banner8.vue?vue&type=style&index=0&id=0d6ac9ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6ac9ea"]])

export default __exports__